module.exports = __webpack_public_path__ + "static/img/tu_1.2.85e656c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tu_1.2.png
// module id = gSVe
// module chunks = 0